export {default} from './hints-input.vue'